/***
 * @file:
 * @author: chengyuntao
 * @Date: 2020-05-25 17:48:30
 */
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorService } from '../../control-value-accessor.service';
import monitor from '../../monitor';

@Component({
  selector: 'dt-form-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormSwitchComponent),
      multi: true,
    },
  ],
})
export class FormSwitchComponent extends ControlValueAccessorService {
  value;
  @Input() loading;
  @Input() size;
  @Input() prop = '';
  // éä¸­æ¶æå­
  @Input() checkedContent = 'å¼';
  // æªéæ¶æå­
  @Input() unCheckedContent = 'å³';
  @Input() associate: any; // å³èçæä½
  @Output() valueChange = new EventEmitter<any>();

  updateChange() {
    this.valueChange.emit(this.value);
    this.selectAssociate({ param: this.value });
    this.updateChanges();
  }
  writeValue(value) {
    if (!this.isFrist) {
      monitor.emit('formValueChange', this.prop);
    } else {
      setTimeout(() => {
        this.selectAssociate({ param: value });
      });
    }
    this.value = value;
    this.updateChanges();
  }

  // ç»ä»¶å³èåå¨ï¼æ§å¶å¯¹åºç»ä»¶
  selectAssociate(option: { [key: string]: any } = {}) {
    if (Array.isArray(this.associate)) {
      this.associate.forEach((i) => {
        this.setAssociateData(option, i);
      });
    }
  }
  setAssociateData(option: { [key: string]: any } = {}, associate) {
    const prop = associate.prop;
    const param: { [key: string]: any } = option.param;
    // è®¾ç½® prop å¯¹åºç»ä»¶ç value
    if (typeof associate === 'object') {
      monitor.emit('setPropValue', { currentProp: this.prop, targetValue: param, ...associate });
    }
  }
}
